import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';
import customerService from '../services/customerService';
import { ROLES } from '../constants/roles'

const SiteContext = createContext(null);

export const SiteProvider = ({ children }) => {
  const { user } = useAuth();
  const [sites, setSites] = useState([]);
  const [selectedSite, setSelectedSite] = useState(null);
  const [loadingSites, setLoadingSites] = useState(true);

  useEffect(() => {
    const loadSites = async () => {
      if (user && (user.role === ROLES.CUSTOMER || user.role === ROLES.TL)) {
        setLoadingSites(true);
        const result = await customerService.getCustomerSites(user.id);
        if (result.success && result.data.length > 0) {
          if (result.data.length > 1) {
            const allSitesOption = { id: 0, site_name: 'All Sites', location: 'Global' };
            setSites([allSitesOption, ...result.data]);
            setSelectedSite(0);
          } else {
            setSites(result.data);
            setSelectedSite(result.data[0].id);
          }
        }
        setLoadingSites(false);
      } else {
        setLoadingSites(false);
      }
    };

    if (user) {
      loadSites();
    }
  }, [user]);

  return (
    <SiteContext.Provider value={{ sites, selectedSite, setSelectedSite, loadingSites }}>
      {children}
    </SiteContext.Provider>
  );
};

export const useSite = () => useContext(SiteContext);